// extracted by mini-css-extract-plugin
module.exports = {"container":"b49a62dc46--container--qYMpV","title":"b49a62dc46--title--tlRpG","socials":"b49a62dc46--socials--GKwIy"};